/** Public offer detail URL for the active site locale. */
export function offerDetailPath(offer, locale = "en") {
  if (!offer) return "/offers";
  if (locale === "fr" && offer.slug_fr) return `/offers/fr/${offer.slug_fr}`;
  if (locale === "de" && offer.slug_de) return `/offers/de/${offer.slug_de}`;
  return `/offers/${offer.slug}`;
}
